// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { handleActions } from 'redux-actions';
import {
    UPLOAD_SAFETY_ATTACHMENTS_SUCCESS,
    CLEAR_SAFETY_ATTACHMENT_INFO,
} from './actions';

export interface AttachmentInfoType {
    fileName: string;
    fileContentStorageId: string;
    mediaTypeName: string;
    fileSizeBytes: number;
}

export const INITIAL_STATE = {};

export type AttachmentFileNamesType = Readonly<typeof INITIAL_STATE>;

const uploadAttachments = (
    state: AttachmentFileNamesType,
    { payload }: { payload: any }
): AttachmentFileNamesType => {
    if (payload) {
        return { ...state, attachmentInfo: payload };
    }
    return state;
};
const clearAttachmentInfo = (
    state: AttachmentFileNamesType,
    { payload }: { payload: any }
): AttachmentFileNamesType => {
    return {};
};
export default handleActions(
    {
        [UPLOAD_SAFETY_ATTACHMENTS_SUCCESS]: uploadAttachments,
        [CLEAR_SAFETY_ATTACHMENT_INFO]: clearAttachmentInfo,
    },
    INITIAL_STATE
);
